<template>
    <v-dialog v-model="show" width="560">
        <v-card v-if="show">
            <v-card-title class="subtitle-1" primary-title>신규 브랜드 등록</v-card-title>
            <v-card-text>
                <v-text-field v-model="editItem.name" label="브랜드 이름" placeholder=" " hide-details class="mt-3"></v-text-field>
                <v-text-field v-model="editItem.code" label="브랜드 코드" placeholder=" " hide-details class="mt-3"></v-text-field>
            </v-card-text>
            <v-card-title class="subtitle-1" primary-title>썸네일</v-card-title>
            <v-card-text>
                <product-image v-model="editItem.thumb" label="썸네일" @remove="removeThumb"></product-image>
            </v-card-text>
            <v-card-title class="subtitle-1" primary-title>서브 썸네일</v-card-title>
            <v-card-text>
                <product-image v-model="editItem.subThumb" label="서브 썸네일" @remove="removeThumb"></product-image>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cancel">취소</v-btn>
                <v-btn color="primary" text @click="save">등록</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import BrandSelect from '@/components/console/shop/brands/brand-select.vue';
import ProductImage from "@/components/console/shop/products/product-image.vue";

export default {
    components: {
        BrandSelect,
        ProductImage
    },
    data(){
        return {
            show: false,

            brands: [],

            editItem: null,
            defaultItem: {
                name: null,
                code: null,
                thumb: null,
                subThumb: null
            }
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { brands } = await api.console.shop.brands.gets({ params: { depth: 1 } });
            this.brands = brands;
        },
        open(){
            this.editItem = JSON.parse(JSON.stringify(this.defaultItem));
            this.show = true;
        },
        close(){
            this.editItem = null;
            this.show = false;
        },
        cancel(){
            this.close();
        },
        async save(){
            let { brand } = await api.console.shop.brands.post({...this.editItem, thumb: null, subThumb: null});
            if(this.editItem.thumb) await api.console.shop.brands.postThumb(brand, this.editItem.thumb)
            if(this.editItem.subThumb) await api.console.shop.brands.postSubThumb(brand, this.editItem.subThumb)
            alert("저장되었습니다");

            this.$emit("save");
            this.close();
            this.init();
        },
        async removeThumb(){
            try{
                if(confirm("상품 썸네일을 삭제하시겠습니까?")){
                    if(this.product._id) await api.console.shop.products.thumb.delete(this.product._id);
                    this.product.thumb = null;
                    this.$emit("input", this.product);
                }
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    }
}
</script>